import { TopBar, BottomBar } from "./App";

export const About = () => {
  return (
    <>
      <div class="scanlines"></div>
      <div className="max-w-2xl mx-auto p-8 min-h-[95vh]">
        <div className="flex flex-col gap-y-12 text-lg">
          <TopBar />
          <div className="text-xl font-bold">Hi, I'm Alec.</div>
          <div>
            I move around a lot. But I grew up in Ohio, and studied Mechanical
            Engineering at Cornell.
          </div>
          <div>
            I realized I wasn't terribly excited about the Mechanical
            Engineering job opportunities at the time, so pivoted my career to
            software. Since 2016 I've been building software for different
            startups, particularly in blockchain and fintech.
          </div>
          <div>
            In 2022 I decided to take the leap and start working for myself. I
            traveled the world for over a year and hit all my bucket list spots
            (Bali, Portugal, Australia, Costa Rica to name a few). I sold
            everything I own except what could fit into a backpack, carry on,
            and check-in luggage. And I got food poisoning 3 times in a month.
          </div>
          <div>
            It was the most exciting and memorable time of my adult life. But I
            got tired of living out of suitcases so decided to head home.
          </div>
          <div>
            During the travels I (occasionally) found time to build an AI
            recruitment platform. I eventually sold it after I arrived back in
            the US. And after a couple months of soul searching I found another
            early startup that excited me and was lucky enough to join.
          </div>
          <div>
            Now I'm focused on learning and figuring out what I want out of life
            :).
          </div>
          <div>
            My life goal is to make a living doing meaningful work, travel, and
            connect with others.
          </div>
        </div>
      </div>
      <BottomBar />
    </>
  );
};
